import React from 'react';
import Streams from '../components/LiveIntel/Streams';
import '../components/LiveIntel/liveIntel.css';
import '../components/LiveIntel/geoStreams.css';
import '../components/Reports/reports.css';

const StreamsPage = () => <Streams />;

export default StreamsPage;
